import { ThemeUICSSObject } from 'theme-ui';
import { spacing } from '../../../../util';
import { getColorsAndStatesByPath } from '../../../../methods';

export const accordion: ThemeUICSSObject = {
  primary: {
    '&, .accordion__item': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      flexShrink: 0,
    },
    '.filtersRender': {
      width: '100%',
    },
    '.accordion__item__button__rightGroup': {
      flexShrink: 0,
    },
    '.accordion__item__button__leftGroup, .accordion__item__button__rightGroup':
      {
        alignItems: 'center',
        display: 'flex',
        gap: 3,

        '& > *': {
          flexShrink: 0,

          '&.accordion__item__button__label': {
            flexShrink: 1,
          },
        },
      },

    '.accordion__item__button__label': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      flexShrink: 1,
      color: 'palette.primary.contrastText',
      fontSize: 16,
    },

    '.accordion__item__button__check': {
      width: '32px',
      height: '32px',
      background: 'palette.background.paper',
      border: '1px solid',
      // borderColor: 'palette.border.field',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'stretch',
      justifyContent: 'stretch',
      p: 2,

      svg: {
        color: 'palette.text.primary',
        height: '100%',
        width: '100%',
      },
    },

    '.accordion__item:not(:first-of-type) > .accordion__item__button': {
      borderTop: '1px solid',
      borderTopColor: 'palette.border.ghost',
    },

    '.accordion__item__content > *': {
      p: 4,
      boxShadow: 'default',
      borderRadius: 'default',
    },

    '.accordion__item__button': {
      width: '100%',
      p: 3,

      '.button__content': {
        alignItems: 'center',
        display: 'flex',
        gap: spacing(3),
        justifyContent: 'space-between',
        width: '100%',
      },
    },
    '.accordion__cell__renderer': {
      display: 'flex',
    },
  },
  panels: {
    variant: 'layout.common.components.accordion.primary',
    overflowX: 'hidden',
    border: 'none',

    '.accordion__item': {
      border: 'none',
    },

    '.accordion__item__button': {
      pl: 4,
      ...getColorsAndStatesByPath('components.accordion.panels'),
      borderLeft: 'none',
      borderRight: 'none',
      borderBottom: 'none',

      '.button__content': {
        alignItems: 'center',
        display: 'flex',
        gap: spacing(3),
        justifyContent: 'space-between',
        width: '100%',
      },
    },

    '.accordion_item__button:first-of-type': {
      borderTop: 'none',
    },

    '.accordion__item__button__label': {
      color: 'palette.text.primary',
      fontWeight: '400',
    },
    '.accordion__item__content[aria-hidden="true"]': {
      border: 'none',
    },
    '.accordion__item__button__check': {
      borderColor: 'palette.border.section',
      borderRadius: '3px',
    },
    '.accordion__item__content': {
      background: 'palette.secondary.light',
      '[data-variant="link"]': {
        px: 0,
      },
      div: {
        border: 'none',
      },
    },
  },
};
